import React from 'react';
import { fromDateKey, dayShort, monthShort } from '../../utils/date';

/** TUE / 6 / Oct block used on appointment cards. */
export default function DateBlock({ date, showMonth = true, size, accent }) {
  const d = fromDateKey(date);
  const cls = ['date-block', size && `date-block--${size}`, accent && `accent--${accent}`].filter(Boolean).join(' ');
  return (
    <div className={cls}>
      <span className="date-block__day">{dayShort(d).toUpperCase()}</span>
      <span className="date-block__num">{d.getDate()}</span>
      {showMonth && <span className="date-block__month">{monthShort(d)}</span>}
    </div>
  );
}
